import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import {
  HistoryStateProvider,
  ModalDispatcher,
  ModalProvider,
  ProviderComposer,
  ToastDispatcher,
  ToastProvider,
} from '@pcmp/react-providers';

import { store } from '@/redux/store';
import { ToastItem } from '@/components/helpers/toast-item';
import { ModalWrapper } from '@/components/helpers/modal-wrapper';
import { AuthProvider } from '@/components/services/auth';
import { MenuProvider } from '@/components/layouts/page-layout/menu';
import AppRouter from '@/app/router';
import ConfigProvider from '@/components/services/config';

interface AppProps {
  basename?: string;
}

export function App({ basename }: AppProps) {
  return (
    <React.StrictMode>
      <ProviderComposer
        providers={
          [
            [BrowserRouter, { basename }],
            [Provider, { store }],
            [AuthProvider, {}],
            [ToastProvider, { ToastItem }],
            [ModalProvider, { ModalWrapper }],
            [HistoryStateProvider],
            [ConfigProvider, {}],
            [MenuProvider, {}],
          ] as unknown as Parameters<typeof ProviderComposer>[0]['providers']
        }
      >
        <ToastDispatcher />
        <ModalDispatcher />
        <AppRouter />
      </ProviderComposer>
    </React.StrictMode>
  );
}
